import { render, staticRenderFns } from "./WaitListQueueIndex.vue?vue&type=template&id=65cbc542"
import script from "./WaitListQueueIndex.vue?vue&type=script&lang=ts"
export * from "./WaitListQueueIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports